import React, { PropsWithChildren } from "react";

const XIconWhite = (props: PropsWithChildren<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      style={{cursor:"pointer"}}

      {...props}
    >
      <path
        fill="#fff"
        d="M9.568 8l4.828-4.781.984-.985c.14-.14.14-.375 0-.562L14.35.64c-.188-.141-.422-.141-.563 0L8.021 6.453 2.208.641C2.068.5 1.833.5 1.646.64L.615 1.67c-.141.188-.141.423 0 .563L6.427 8 .615 13.813c-.141.14-.141.374 0 .562l1.03 1.031c.188.14.423.14.563 0l5.813-5.812 4.781 4.828.985.984c.14.14.374.14.562 0l1.031-1.031c.14-.188.14-.422 0-.563L9.568 8z"
      ></path>
    </svg>
  );
};

export default React.memo(XIconWhite);
